const projects = [
    {
        date: '2022',
        image: '/images/projects/crypto.png',
        githublink: 'https://github.com/Thanaxx',
        liveproject: 'https://effortless-kheer-3ee7c5.netlify.app/',
        subject: 'NextGen',
        caption: 'An informative website that not only helps you learn and comprehend the value of cryptocurrency by providing educational blogs for users to read, but also provides the most up-to-date crypto exchange rate.',
        subjectB: 'STACKS',
        captionB: 'ReactJS, Material UI, Material UI Icons, Axios, and API.'
    },
    
    {
        date: '2022',
        image: '/images/projects/wbuild.png',
        githublink: 'https://github.com/Thanaxx',
        liveproject: 'https://nifty-bhaskara-9c7adf.netlify.app/',
        subject: 'WBLD',
        caption: 'A website that addresses the clients concerns regarding to their business design and development matters, allowing to solve them remotely and conveniently.',
        subjectB: 'STACKS',
        captionB: 'ReactJS, Styled-components, and React Icons.'
    },

    // {
    //     date: '2022',
    //     image: '/images/projects/mdcr.png',
    //     githublink: 'https://github.com/Thanaxx',
    //     liveproject: 'https://festive-babbage-c7450f.netlify.app/',
    //     subject: 'MEDCARE',
    //     caption: 'A web application that connects patients to various types of doctors all around the world who may address their health concerns with such a one tap.',
    //     subjectB: 'STACKS',
    //     captionB: 'ReactJS, Styled-components, and React Icons.'
    // },

    // {
    //     date: '2022',
    //     image: '/images/projects/restu.png',
    //     githublink: 'https://github.com/Thanaxx',
    //     liveproject: 'https://zealous-thompson-fd42cd.netlify.app/',
    //     subject: 'Foodie',
    //     caption: 'A restaurant website that allows you to build an order and make reservations at nearby restaurants in a convenient manner.',
    //     subjectB: 'STACKS',
    //     captionB: 'HTML5, CSS3, and JavaScript.'
    // },

    {
        date: '2022',
        image: '/images/projects/frntr.png',
        githublink: 'https://github.com/Thanaxx',
        liveproject: 'https://naughty-ritchie-f772e5.netlify.app/',
        subject: 'FRNTR',
        caption: 'An e-commerce website that allows you to order and pay for home decor from the comfort of your own home.',
        subjectB: 'STACKS',
        captionB: 'HTML5, CSS3, and JavaScript.'
    },

    {
        date: '2022',
        image: '/images/projects/badiangan.png',
        githublink: 'https://github.com/Thanaxx',
        liveproject: 'https://zealous-thompson-fd42cd.netlify.app/',
        subject: 'Badiangan',
        caption: 'A static website of the mucipality of Badiangan, Iloilo that showcases their tradition, government, people, beautiful places and current news which can be access conveniently ',
        subjectB: 'STACKS',
        captionB: 'ReactJS, Styled-components, and React Icons.'
    },

    // {
    //     date: '2022',
    //     image: '/images/projects/nws.png',
    //     githublink: 'https://github.com/Thanaxx',
    //     liveproject: 'https://rococo-croquembouche-1d0f2e.netlify.app/',
    //     subject: 'NewsBreak',
    //     caption: 'A news website that displays articles and breaking news headline from news sources and blogs across the web using NewsAPI.',
    //     subjectB: 'STACKS',
    //     captionB: 'ReactJS, Styled-components, React Icons, Axios, and News API.'
    // },
]

export default projects;